import { Enums } from '@bode-canada/core';
import { OptionProperty } from '@/ui-kit/components/form/controls/components/select/enums';
import { RadioOptionProperty } from '@/ui-kit/components/form/controls/components/radio/enums';
import { ResetStep } from '../reset/enums';

const PROVINCE_NAME = {
  [Enums.ProvinceEnum.AB]: 'Alberta',
  [Enums.ProvinceEnum.BC]: 'British Columbia',
  [Enums.ProvinceEnum.ON]: 'Ontario',
};

const OTHER_OPTION = {
  [OptionProperty.Label]: 'Other',
  [OptionProperty.Value]: 'Other',
};

export const LOCATION_OPTIONS = Object.entries(PROVINCE_NAME)
  .map(([province, provinceName]) => (
    { [OptionProperty.Label]: provinceName, [OptionProperty.Value]: province }))
  .concat([OTHER_OPTION]);

export const MOTIVATION_OPTIONS = [
  {
    [OptionProperty.Label]: 'Buy',
    [OptionProperty.Value]: 'Buy',
  },
  {
    [OptionProperty.Label]: 'Sell',
    [OptionProperty.Value]: 'Sell',
  },
  {
    [OptionProperty.Label]: 'See sold data',
    [OptionProperty.Value]: 'See sold data',
  },
  {
    [OptionProperty.Label]: 'Use Prō Marketplace',
    [OptionProperty.Value]: 'Use Prō Marketplace',
  },
];

export const ROLE_OPTIONS = [
  {
    [RadioOptionProperty.Value]: 'First-time buyer',
    [RadioOptionProperty.Label]: 'First-time buyer',
  },
  {
    [RadioOptionProperty.Value]: 'Homeowner',
    [RadioOptionProperty.Label]: 'Homeowner',
  },
  {
    [RadioOptionProperty.Value]: 'Prō',
    [RadioOptionProperty.Label]: 'Home Service Prō',
  },
  {
    [RadioOptionProperty.Value]: 'Builder',
    [RadioOptionProperty.Label]: 'Builder',
  },
  {
    [RadioOptionProperty.Value]: 'Realtor',
    [RadioOptionProperty.Label]: 'Realtor',
  },
  {
    [RadioOptionProperty.Value]: 'Investor',
    [RadioOptionProperty.Label]: 'Investor',
  },
];

export const TIME_FRAME_OPTIONS = [
  {
    [RadioOptionProperty.Value]: 'Within 3 months',
    [RadioOptionProperty.Label]: 'Within 3 months',
  },
  {
    [RadioOptionProperty.Value]: 'Within 6 months',
    [RadioOptionProperty.Label]: 'Within 6 months',
  },
  {
    [RadioOptionProperty.Value]: 'Within 12 months',
    [RadioOptionProperty.Label]: 'Within 12 months',
  },
  {
    [RadioOptionProperty.Value]: '12 months +',
    [RadioOptionProperty.Label]: '12 months +',
  },
];

export const AUTH_FORM_TITLES = {
  Login: 'Welcome back!',
  SignUp: 'Create a Bōde account',
  SignUpPro: 'Create your Prō account',
  ResetPassword: {
    [ResetStep.Email]: 'Can\'t log in?',
    [ResetStep.Code]: 'Your verification code was sent to your inbox',
  },
  AdditionalInformation: 'Help us personalize your Bōde experience',
  SignUpConfirm: 'Your verification code was sent to',
};

export const AUTH_FORM_TITLE_TOOLTIPS = {
  ResetPassword: 'If you created your account using Google or Facebook, you will need to re-set your password on those platforms. This feature is for accounts created via email.',
};

export const AUTH_FORM_LEGENDS = {
  General: 'Get access to all the information and tools you need to buy and sell a home - yourself!',
  Gated: `Regulation stipulates that the information requires an account. But once you have an
    account, you will have access to all the home data you have ever wanted.`,
  ProMarketplace: 'Receive service requests, manage your Prōfile and chat with homeowners.',
  ResetPassword: 'We\'ll send a recovery link to:',
  Login: 'Log into your Bōde account below',
};

export const ERROR_EXCEPTIONS = {
  NotAuthorizedException: 'NotAuthorizedException',
  InvalidParameterException: 'InvalidParameterException',
  NotResendConfirmationException: 'NotResendConfirmationException',
  NotVerifiedEmailException: 'NotVerifiedEmailException',
  UserNotConfirmedException: 'UserNotConfirmedException',
  LimitExceededException: 'LimitExceededException',
  LimitPasswordExceededException: 'LimitPasswordExceededException',
  UserLambdaValidationException: 'UserLambdaValidationException',
  CheckoutMarketDataAnalysis: 'CheckoutMarketDataAnalysis',
  LoginInstead: 'LoginInstead',
  InvalidPasswordException: 'InvalidPasswordException',
  UsernameExistsException: 'UsernameExistsException',
  CodeMismatchException: 'CodeMismatchException',
};

export const DEFAULT_CONFIRMATION_CODE_LENGTH = 6;
export const DEFAULT_MIN_PASSWORD_LENGTH = 8;
export const DEFAULT_MAX_PASSWORD_LENGTH = 40;
export const PASSWORD_MIN_LENGTH_ERROR_MESSAGE = `Your password must contain at least ${DEFAULT_MIN_PASSWORD_LENGTH} characters`;
export const PASSWORD_MAX_LENGTH_ERROR_MESSAGE = `Character limit of ${DEFAULT_MAX_PASSWORD_LENGTH} exceeded`;
export const CONFIRMATION_CODE_ERROR_MESSAGE = 'The code should be 6 digits';
